export default "__VITE_ASSET__DWWl_XHc__"